import React, { FunctionComponent, useState } from "react";
import {
  Table,
  MuiThemeProvider,
  Switch,
  Grid,
  Tooltip
} from "@material-ui/core";
import moment from "moment";
import { TerminalUsersType } from "../../terminalUsers";
import { useStore } from "../../../../store";
import { StatusUpdateAuthenticationDialog } from "../StatusUpdateAuthentication";
import { SnackBar } from "../../../SnackBar";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../../useTableStyle";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface TerminalUsersTableProps {
  terminalUsers: Array<TerminalUsersType> | any;
  editLoggedUsersPermission:boolean;
}

export const TerminalUsersTable: FunctionComponent<TerminalUsersTableProps> = ({
  terminalUsers,
  editLoggedUsersPermission
}) => {
  const getMuiTheme = useTableStyles();
  const [loggedPosUserList] = useStore("loggedPosUserList");
  const [updateStatusDailog, setUpdateStatusDailog] = useState<boolean>(false);
  const [loggedUserObject, setloggedUserObject] = useState<Object>();
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [terminalStatus, setTerminalStatus] = useState<string>("");

  const columns = [
    "Name",
    "Role",
    "Active Terminal",
    "Last Active",
    "Status",
    editLoggedUsersPermission?"Login Status":""
    // "Login Status",
  ];

  const onCloseSnackbar = () => {
    setTerminalStatus("");
  };
  const statusClick = (id: number) => {
    const loggedPosUser =
      loggedPosUserList &&
      loggedPosUserList.find((user: any) => user.id === id);
    if (loggedPosUser) {
      if (loggedPosUser.islogin === null) {
        setUpdateStatusDailog(false);
      } else {
        setUpdateStatusDailog(true);
        setloggedUserObject(loggedPosUser);
      }
    }
  };
  const statusUpdateClose = () => {
    setUpdateStatusDailog(false);
  };
  const statusAuthClose = () => {
    setUpdateStatusDailog(false);
    setSnackbarColor("green");
    setTerminalStatus("Status successfully updated");
  };
  if (terminalUsers && terminalUsers.length > 0) {
    return (
      <div>
        <SnackBar
          status={terminalStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Terminal Users List"}
              data={terminalUsers.map((terminaluser: any) => {
                return [
                  terminaluser.full_name,
                  terminaluser.type_of_user,
                  terminaluser.active_terminal,
                  terminaluser.last_login !== null
                    ? moment(terminaluser.last_login).fromNow()
                    : "Never logged in",
                  terminaluser.status,
                  <Grid container direction="row" spacing={2}
                  style={{display:editLoggedUsersPermission?"":"none"}}
                  >
                    <Grid item>
                      <Tooltip
                        title={
                          terminaluser.islogin === true
                            ? "Change status to Inactive"
                            : "Change status to Active"
                        }
                      >
                        <Switch
                          checked={terminaluser.islogin === true ? true : false}
                          onChange={() =>
                            statusClick(terminaluser.id)
                          }
                          color="primary"
                          name="status"
                          inputProps={{ "aria-label": "primary checkbox" }}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        {updateStatusDailog ? (
          <StatusUpdateAuthenticationDialog
            statusUpdateClose={statusUpdateClose}
            loggedUserObject={loggedUserObject}
            statusAuthClose={statusAuthClose}
          />
        ) : null}
      </div>
    );
  } else {
    return (
      <div>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Terminal Users List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
